import React from 'react';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import './PlugInHybrid.scss';
export default function PlugInHybrid({ fields }) {
  return (
    <div className={'container plugIn-hybrid'}>
      <div className={' wrapper'} data-aos="fade-up">
        <h2 className={'title'}>{fields?.title?.value}</h2>
        <div className={'cards'}>
          {fields.Item &&
            fields.Item.map((option, index) => (
              <div className={'card'} key={index}>
                <div className={'card_imageContainer'} data-aos="fade-up" data-aos-offset={100}>
                  <div className={'card_imageContainer_image'}>
                    <Image field={option?.fields.image}></Image>
                  </div>
                </div>
                <div className={'card_title'} data-aos="fade-up" data-aos-offset={100}>
                  <RichText field={option?.fields?.title} />
                </div>
                <div className={'card_text'} data-aos="fade-up" data-aos-offset={100}>
                  <RichText field={option?.fields.desc} />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
